(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rn-header"]) return;
  try {
    
document.addEventListener('click', (event) => { document.querySelectorAll('.rn-hdr .rgn[open]').forEach((d) => { if (!d.contains(event.target)) d.open = false; }); }); document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = event.target.closest('.rn-hdr .mnav[open], .rn-hdr .rgn[open]');
  if (!menu) return;
  menu.open = false;
  menu.querySelector('summary')?.focus();
  event.preventDefault();
});

  } catch(e) { console.error(e); }
})();
})();
